/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.platinium.recherche.ts
 *
 * Messages du lot P3, recherche filtrée et recherches enregistrées (chantier Platinium, cahier des charges
 * app/docs/CDC-PLATINIUM.md).
 *
 * Fichier créé VIDE et déjà branché par la vague 0 (fusionné dans fr.ts,
 * inscrit au garde-fou des sous-catalogues) : l'agent de ce lot n'écrit QUE
 * dans ce fichier. Les textes communs (statut, garde de l'espace, texte de
 * l'accord) sont dans fr.platinium.socle.ts : les réutiliser, ne pas les
 * redéfinir (le garde-fou refuse une clé définie deux fois).
 *
 * Règles : préfixe de clé « platinium.recherche. » ; vouvoiement, apostrophes
 * typographiques, aucun tiret cadratin, aucun mot « atelier » en dur, aucun
 * nom, lieu ni type d'événement écrit en dur ({eventTypeDef}).
 *
 * Aucun libellé d'âge, de sexe, de photo, de nationalité ni de handicap :
 * ces critères n'existent pas (CDC 6.1), l'écran le dit une fois, en clair.
 *
 * Mikael - chef de projet - 2026-10-14
 */
export const messagesPlatiniumRechercheFr: Record<string, string> = {
  // ── Barre de recherche ────────────────────────────────────────────────
  'platinium.recherche.titre': 'Rechercher dans les CV',
  'platinium.recherche.intro':
    'Les candidats qui ont accepté que les entreprises recherchent leur CV, et qui cherchent encore. Chaque CV ouvert et chaque coordonnée consultée sont inscrits dans le journal du candidat.',
  'platinium.recherche.mots.label': 'Mots obligatoires',
  'platinium.recherche.mots.aide': 'Tous ces mots doivent figurer dans le CV, au début d’un mot, accents ignorés.',
  'platinium.recherche.mots.placeholder': 'soudure, électricité',
  'platinium.recherche.lancer': 'Rechercher',
  'platinium.recherche.reinitialiser': 'Effacer les filtres',
  'platinium.recherche.tri.label': 'Trier par',
  'platinium.recherche.tri.pertinence': 'Pertinence',
  'platinium.recherche.tri.date': 'Date du CV',
  'platinium.recherche.tri.distance': 'Distance',
  'platinium.recherche.tri.retombe': 'Sans offre, profil ni mot obligatoire, les résultats sont triés par date du CV.',

  // ── Panneau des filtres ───────────────────────────────────────────────
  'platinium.recherche.filtres.ouvrir': 'Plus de filtres',
  'platinium.recherche.filtres.fermer': 'Masquer les filtres',
  'platinium.recherche.filtres.actifs': '{n, plural, =0 {aucun filtre} one {# filtre} other {# filtres}}',
  'platinium.recherche.filtres.jamais':
    'L’âge, le sexe, la photo, la nationalité et le handicap ne sont jamais des critères de recherche.',
  'platinium.recherche.filtres.tous': 'Indifférent',

  'platinium.recherche.section.declare': 'Ce que la personne déclare',
  'platinium.recherche.section.profil': 'Distance, disponibilité, diplôme',
  'platinium.recherche.section.cv': 'Le contenu du CV',
  'platinium.recherche.section.evenement': 'Pendant {eventTypeDef}',
  'platinium.recherche.section.suivi': 'Notre suivi',

  'platinium.recherche.champ.situation': 'Situation',
  'platinium.recherche.champ.recherche': 'Ce qu’elle recherche',
  'platinium.recherche.champ.secteur': 'Secteur',
  'platinium.recherche.champ.experience': 'Expérience',
  'platinium.recherche.champ.structure': 'Établissement ou structure',
  'platinium.recherche.champ.centre': 'Distance autour de',
  'platinium.recherche.champ.centre.aucun': 'Pas de recherche par distance',
  'platinium.recherche.champ.centre.entreprise': 'L’adresse de votre entreprise, {adresse}',
  'platinium.recherche.champ.centre.entrepriseAbsente': 'L’adresse de votre entreprise (code postal manquant sur votre fiche)',
  'platinium.recherche.champ.centre.commune': 'Une commune',
  'platinium.recherche.champ.commune': 'Commune',
  'platinium.recherche.champ.rayon': 'Rayon',
  'platinium.recherche.champ.rayon.aucun': 'Sans limite',
  'platinium.recherche.champ.rayon.valeur': '{km} km',
  'platinium.recherche.champ.respecterMobilite': 'Seulement les candidats qui acceptent cette distance',
  'platinium.recherche.champ.mobilite': 'Mobilité acceptée, au moins',
  'platinium.recherche.champ.permis': 'Permis',
  'platinium.recherche.champ.vehicule': 'A un véhicule',
  'platinium.recherche.champ.dispoAvant': 'Disponible avant le',
  'platinium.recherche.champ.contrats': 'Contrat souhaité',
  'platinium.recherche.champ.contrats.aide': 'Les candidats ouverts à tout contrat sont inclus.',
  'platinium.recherche.champ.temps': 'Temps de travail',
  'platinium.recherche.champ.diplome': 'Diplôme minimum',
  'platinium.recherche.champ.motsExclus': 'Mots exclus',
  'platinium.recherche.champ.motsExclus.aide': 'Aucun de ces mots ne doit figurer dans le CV.',
  'platinium.recherche.champ.competences': 'Compétences',
  'platinium.recherche.champ.competences.aide': 'Au moins une de ces compétences, séparées par des virgules.',
  'platinium.recherche.champ.langues': 'Langues citées dans le CV',
  'platinium.recherche.champ.cvDepuis': 'CV déposé ou mis à jour depuis le',
  'platinium.recherche.champ.present': 'Présent le jour même',
  'platinium.recherche.champ.stand': 'Passé sur notre stand',
  'platinium.recherche.champ.candidature': 'Nous a envoyé sa candidature',
  'platinium.recherche.champ.ateliers': 'A participé à {lexWorkshopIndef} de cette liste',
  'platinium.recherche.champ.ateliers.aucun': 'Aucun choix possible pour le moment.',
  'platinium.recherche.champ.note': 'Note donnée par votre équipe au scan',
  'platinium.recherche.champ.note.valeur': '{n, plural, one {# étoile ou plus} other {# étoiles ou plus}}',
  'platinium.recherche.champ.pasVu': 'Pas encore vu (ni CV ni coordonnées ouverts)',
  'platinium.recherche.champ.vivier': 'Vivier',
  'platinium.recherche.champ.vivier.tous': 'Dans le vivier ou non',
  'platinium.recherche.champ.vivier.dans': 'Déjà dans le vivier',
  'platinium.recherche.champ.vivier.hors': 'Pas encore dans le vivier',
  'platinium.recherche.champ.ecartes': 'Candidats écartés',
  'platinium.recherche.champ.ecartes.masques': 'Masqués',
  'platinium.recherche.champ.ecartes.inclus': 'Affichés aussi',
  'platinium.recherche.champ.ecartes.seuls': 'Seulement eux',
  'platinium.recherche.champ.correspondance': 'Correspond à',
  'platinium.recherche.champ.correspondance.aucune': 'Ni offre ni profil',
  'platinium.recherche.champ.correspondance.offres': 'Nos offres',
  'platinium.recherche.champ.correspondance.profils': 'Nos profils recherchés',
  'platinium.recherche.champ.scoreMin': 'Score minimum (sur 100)',

  // ── Valeurs ───────────────────────────────────────────────────────────
  'platinium.recherche.val.situation.demandeur_emploi': 'Demandeur d’emploi',
  'platinium.recherche.val.situation.salarie_reconversion': 'Salarié en reconversion',
  'platinium.recherche.val.situation.etudiant': 'Étudiant',
  'platinium.recherche.val.situation.lyceen': 'Lycéen ou collégien',
  'platinium.recherche.val.situation.en_formation': 'En formation ou en alternance',
  'platinium.recherche.val.situation.autre': 'Autre situation',
  'platinium.recherche.val.recherche.emploi': 'Un emploi',
  'platinium.recherche.val.recherche.alternance': 'Une alternance',
  'platinium.recherche.val.recherche.stage': 'Un stage',
  'platinium.recherche.val.recherche.formation': 'Une formation',
  'platinium.recherche.val.recherche.information': 'S’informe seulement',
  'platinium.recherche.val.recherche.non': 'Rien de précis',
  'platinium.recherche.val.experience.debutant': 'Débutant',
  'platinium.recherche.val.experience.intermediaire': 'Intermédiaire (1 à 3 ans)',
  'platinium.recherche.val.experience.confirme': 'Confirmé (3 à 10 ans)',
  'platinium.recherche.val.experience.expert': 'Expert (plus de 10 ans)',
  'platinium.recherche.val.permis.aucun': 'Aucun permis',
  'platinium.recherche.val.permis.b': 'Permis B',
  'platinium.recherche.val.permis.b_en_cours': 'Permis B en cours',
  'platinium.recherche.val.permis.c': 'Permis C',
  'platinium.recherche.val.permis.ce': 'Permis CE',
  'platinium.recherche.val.permis.d': 'Permis D',
  'platinium.recherche.val.permis.autre': 'Autre permis',
  'platinium.recherche.val.contrat.cdi': 'CDI',
  'platinium.recherche.val.contrat.cdd': 'CDD',
  'platinium.recherche.val.contrat.interim': 'Intérim',
  'platinium.recherche.val.contrat.alternance': 'Alternance',
  'platinium.recherche.val.contrat.apprentissage': 'Apprentissage',
  'platinium.recherche.val.contrat.stage': 'Stage',
  'platinium.recherche.val.contrat.saisonnier': 'Saisonnier',
  'platinium.recherche.val.contrat.indifferent': 'Tout contrat',
  'platinium.recherche.val.temps.plein': 'Temps plein',
  'platinium.recherche.val.temps.partiel': 'Temps partiel',
  'platinium.recherche.val.temps.indifferent': 'Temps plein ou partiel',
  'platinium.recherche.val.diplome.sans': 'Sans diplôme',
  'platinium.recherche.val.diplome.cap_bep': 'CAP ou BEP',
  'platinium.recherche.val.diplome.bac': 'Bac',
  'platinium.recherche.val.diplome.bac2': 'Bac +2',
  'platinium.recherche.val.diplome.bac3': 'Bac +3',
  'platinium.recherche.val.diplome.bac5': 'Bac +5',
  'platinium.recherche.val.diplome.doctorat': 'Doctorat',
  'platinium.recherche.val.mobilite.km': '{km} km',
  'platinium.recherche.val.mobilite.region': 'Toute la région',
  'platinium.recherche.val.mobilite.nationale': 'Mobilité nationale',
  'platinium.recherche.val.dispo.immediate': 'Disponible tout de suite',
  'platinium.recherche.val.dispo.date': 'Disponible le {date}',
  'platinium.recherche.val.dispo.preavis': 'En poste, libre le {date}',
  'platinium.recherche.val.dispo.preavisSansDate': 'En poste, avec un préavis',
  'platinium.recherche.val.dispo.a_preciser': 'Disponibilité à préciser',

  // ── Résultats ─────────────────────────────────────────────────────────
  'platinium.recherche.resultats.titre': 'Résultats',
  'platinium.recherche.resultats.total': '{n, plural, =0 {Aucun candidat} one {# candidat} other {# candidats}}',
  'platinium.recherche.resultats.chargement': 'Recherche en cours…',
  'platinium.recherche.resultats.vide': 'Aucun candidat ne correspond à ces filtres.',
  'platinium.recherche.resultats.videAide': 'Retirez un filtre ou élargissez la distance.',
  'platinium.recherche.resultats.sansCommune':
    '{n, plural, one {# candidat sans commune ne peut pas être filtré par distance} other {# candidats sans commune ne peuvent pas être filtrés par distance}}.',
  'platinium.recherche.resultats.centre': 'Distances calculées depuis {lieu}.',
  'platinium.recherche.resultats.critere': 'Score calculé sur : {titre}.',
  'platinium.recherche.erreur': 'La recherche n’a pas pu aboutir. Réessayez dans un instant.',
  'platinium.recherche.erreur.interdit': 'Ce critère n’est pas autorisé.',
  'platinium.recherche.erreur.valeur': 'Un filtre contient une valeur invalide. Vérifiez vos filtres.',
  'platinium.recherche.erreur.centre': 'Le centre de la recherche par distance est introuvable. Choisissez une autre commune.',
  'platinium.recherche.erreur.debit': 'Trop de recherches en peu de temps. Patientez quelques minutes.',
  'platinium.recherche.erreur.options': 'Les listes de filtres n’ont pas pu être chargées.',

  'platinium.recherche.page.precedente': 'Page précédente',
  'platinium.recherche.page.suivante': 'Page suivante',
  'platinium.recherche.page.position': 'Page {page} sur {pages}',

  // ── Sélection multiple ────────────────────────────────────────────────
  'platinium.recherche.selection.tout': 'Tout sélectionner sur cette page',
  'platinium.recherche.selection.nombre': '{n, plural, =0 {Aucune sélection} one {# sélectionné} other {# sélectionnés}}',
  'platinium.recherche.selection.coupDeCoeur': 'Coup de cœur pour la sélection',
  'platinium.recherche.selection.ecarter': 'Écarter la sélection',
  'platinium.recherche.selection.choisir': 'Sélectionner {nom}',

  // ── Carte de résultat ─────────────────────────────────────────────────
  'platinium.recherche.carte.score': 'Score {score} sur 100',
  'platinium.recherche.carte.pourquoi': 'Pourquoi :',
  'platinium.recherche.carte.pointsForts': 'Points forts du CV',
  'platinium.recherche.carte.nonIndexe': 'CV non lu automatiquement : ouvrez-le pour le découvrir.',
  'platinium.recherche.carte.distance': 'à {km} km',
  'platinium.recherche.carte.sansCommune': 'Commune non renseignée',
  'platinium.recherche.carte.mobilite': 'Se déplace : {valeur}',
  'platinium.recherche.carte.vehicule': 'Véhiculé',
  'platinium.recherche.carte.domaine': 'en {domaine}',
  'platinium.recherche.carte.cvLe': 'CV du {date}',
  'platinium.recherche.carte.present': 'Présent le jour même',
  'platinium.recherche.carte.stand': 'Passé sur notre stand',
  'platinium.recherche.carte.note': 'Notre note : {n} sur 5',
  'platinium.recherche.carte.candidature': 'Nous a envoyé sa candidature',
  'platinium.recherche.carte.vivier': 'Dans le vivier',
  'platinium.recherche.carte.ecarte': 'Écarté',
  'platinium.recherche.carte.voirCv': 'Voir le CV',
  'platinium.recherche.carte.voirCv.aria': 'Voir le CV de {nom}, dans un nouvel onglet',
  'platinium.recherche.carte.coordonnees': 'Coordonnées',
  'platinium.recherche.carte.coordonnees.enCours': 'Chargement…',
  'platinium.recherche.carte.coordonnees.aucune': 'Aucune coordonnée renseignée.',
  'platinium.recherche.carte.coordonnees.note': 'Cette consultation est inscrite dans le journal du candidat.',
  'platinium.recherche.carte.coordonnees.erreur': 'Les coordonnées ne sont pas accessibles.',
  'platinium.recherche.carte.coupDeCoeur': 'Coup de cœur',
  'platinium.recherche.carte.ecarter': 'Écarter',
  'platinium.recherche.carte.retablir': 'Rétablir',

  // ── Retours des actions ───────────────────────────────────────────────
  'platinium.recherche.toast.vivier':
    '{ajoutes, plural, =0 {Aucun nouvel ajout au vivier} one {# candidat ajouté au vivier} other {# candidats ajoutés au vivier}}{deja, plural, =0 {} one {, # déjà présent} other {, # déjà présents}}.',
  'platinium.recherche.toast.vivierErreur': 'Le vivier n’a pas pu être mis à jour. Réessayez plus tard.',
  'platinium.recherche.toast.ecartes': '{n, plural, =0 {Personne n’a été écarté} one {# candidat écarté} other {# candidats écartés}}.',
  'platinium.recherche.toast.retablis': '{n, plural, =0 {Personne n’a été rétabli} one {# candidat rétabli} other {# candidats rétablis}}.',
  'platinium.recherche.toast.erreur': 'L’action n’a pas abouti. Réessayez.',

  // ── Recherches enregistrées ───────────────────────────────────────────
  'platinium.recherche.enregistrees.titre': 'Recherches enregistrées',
  'platinium.recherche.enregistrees.vide': 'Aucune recherche enregistrée pour le moment.',
  'platinium.recherche.enregistrees.appliquer': 'Appliquer',
  'platinium.recherche.enregistrees.appliquer.aria': 'Appliquer la recherche {nom}',
  'platinium.recherche.enregistrees.auteur': 'par {auteur}',
  'platinium.recherche.enregistrees.privee': 'Privée',
  'platinium.recherche.enregistrees.partagee': 'Partagée',
  'platinium.recherche.enregistrees.alerte.aucune': 'Pas d’alerte',
  'platinium.recherche.enregistrees.alerte.jour': 'Alerte chaque jour',
  'platinium.recherche.enregistrees.alerte.semaine': 'Alerte chaque semaine',
  'platinium.recherche.enregistrees.alerte.label': 'Alerte par courriel',
  'platinium.recherche.enregistrees.alerte.aide': 'Le courriel liste les nouveaux CV qui correspondent, seulement s’il y en a.',
  'platinium.recherche.enregistrees.alerte.aria': 'Alerte de la recherche {nom}',
  'platinium.recherche.enregistrees.enregistrer': 'Enregistrer cette recherche',
  'platinium.recherche.enregistrees.nom': 'Nom de la recherche',
  'platinium.recherche.enregistrees.partager': 'Partager avec les recruteurs de l’entreprise',
  'platinium.recherche.enregistrees.partage.aria': 'Partager la recherche {nom}',
  'platinium.recherche.enregistrees.valider': 'Enregistrer',
  'platinium.recherche.enregistrees.annuler': 'Annuler',
  'platinium.recherche.enregistrees.gerer': 'Gérer',
  'platinium.recherche.enregistrees.gerer.aria': 'Gérer la recherche {nom}',
  'platinium.recherche.enregistrees.renommer': 'Renommer',
  'platinium.recherche.enregistrees.renommer.aria': 'Renommer la recherche {nom}',
  'platinium.recherche.enregistrees.nouveauNom': 'Nouveau nom',
  'platinium.recherche.enregistrees.mettreAJour': 'Remplacer par les filtres actuels',
  'platinium.recherche.enregistrees.mettreAJour.aria': 'Remplacer les filtres de la recherche {nom} par les filtres actuels',
  'platinium.recherche.enregistrees.supprimer': 'Supprimer',
  'platinium.recherche.enregistrees.supprimer.aria': 'Supprimer la recherche {nom}',
  'platinium.recherche.enregistrees.supprimer.confirmer': 'Supprimer la recherche « {nom} » ?',
  'platinium.recherche.enregistrees.toast.creee': 'Recherche enregistrée.',
  'platinium.recherche.enregistrees.toast.modifiee': 'Recherche mise à jour.',
  'platinium.recherche.enregistrees.toast.supprimee': 'Recherche supprimée.',
  'platinium.recherche.enregistrees.toast.erreur': 'La recherche n’a pas pu être enregistrée. Vérifiez son nom et vos filtres.',
};
